var map = {
	"./staff_u12_01.png": 68366,
	"./staff_u12_02.png": 25546,
	"./staff_u15_01.png": 12832,
	"./staff_u15_02.png": 94311,
	"./staff_u15_03.png": 49985,
	"./staff_u15_04.png": 28059,
	"./staff_u15_05.png": 32708,
	"./staff_u18_01.png": 96670,
	"./staff_u18_02.png": 58482,
	"./staff_u18_03.png": 62760,
	"./staff_u18_04.png": 872,
	"./staff_u18_05.png": 13460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76733;